<template>
  <section class="hero-section">
    <div
      class="hero-section__container"
      :style="{
        '--cover-large': `url(${offerConfig.offer.hero.lg}`,
        '--cover-small': `url(${offerConfig.offer.hero.sm}`,
      }"
    >
      <h1 class="hero-section__logos">
        <img src="@/assets/images/playkids-logo.svg" class="hero-section__logos__playkids" />
        <img class="hero-section__logos__offer" :alt="offerConfig.partner.name" :src="offerConfig.partner.logo" v-if="offerConfig.partner" />
      </h1>

      <div class="hero-section__text">
        <h2 v-html="headerHeading" />

        <p v-html="headerText" />

        <template v-if="offerConfig.discount.from">
          <h5>De:</h5>

          <p>
            <ul>
              <li
                v-for="(item, index) in offerConfig.discount.from"
                :key="index"
              >
                <del v-html="item" />
              </li>
            </ul>
          </p>

          <h5>Por:</h5>
          <p>
            <ul>
              <li
                v-for="(item, index) in offerConfig.discount.to"
                :key="index"
                v-html="item"
              />
            </ul>
          </p>
        </template>

        <h5>Benefícios:</h5>

        <p>
          <ul>
            <li>Libere mais de 5 mil desenhos, livros, jogos e atividades</li>
            <li>Assista quando e onde quiser, mesmo sem internet</li>
            <li>Garanta mais conexões em família, dentro e fora das telas</li>
            <li
              v-for="(item, index) in offerConfig.discount.benefitsAppend"
              :key="index"
              v-html="item"
            />
          </ul>
        </p>
      </div>

      <a :href="ctaUrl" class="hero-section__cta">
        {{ ctaLabel }}
      </a>
      <p v-if="offerConfig.partner.name === 'Porto Seguro'" style="font-size:12px; padding-top:5px">*Desconto válido apenas para o plano anual, por tempo limitado</p>
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'HeroSection',

  computed: {
    ...mapState('config', ['hosts']),

    ...mapState('offers', {
      offerConfig: 'current'
    }),

    ...mapGetters('offers', [
      'headerHeading',
      'headerText'
    ]),

    ctaUrl () {
      const urlBase = `${this.hosts.app}/${this.offerConfig.isRedeemable ? 'redeem' : 'signup'}?offer=${this.$route.params.offer}`
      const coupon = encodeURIComponent(this.$route.query.coupon)

      return coupon !== 'undefined'
        ? `${urlBase}?coupon=${coupon}`
        : urlBase
    },

    ctaLabel () {
      const { discount, isRedeemable, buttonLabelCustom } = this.offerConfig

      if (buttonLabelCustom) {
        return buttonLabelCustom
      }

      if (isRedeemable) {
        return `Vincular assinatura ${this.offerConfig.partner.name}`
      }

      switch (discount) {
        case 0:
          return 'Assine agora'

        case 100:
          return 'Experimente grátis'
      }

      return 'Assine com desconto'
    }
  }
}
</script>

<style lang="scss" scoped>
.hero-section {
  background: {
    image:
      url('~@/assets/images/stuff-1.svg'),
      url('~@/assets/images/stuff-2.svg'),
      url('~@/assets/images/stuff-3.svg'),
      url('~@/assets/images/stuff-4.svg');
    repeat: no-repeat;
    position:
      calc(50% + 30px) 300px,
      calc(50% + 20px) 500px,
      calc(50% - 40px) 80px,
      calc(50% - 540px) 350px;
    size: 60px auto;
  }

  &__container {
    max-width: map-get($breakpoint, 'large');
    min-height: 600px;
    padding: 40px 500px 60px 20px;
    margin: 0 auto;
    background: {
      image: var(--cover-large);
      repeat: no-repeat;
      position: 100% 0;
      size: 400px auto;
    }
  }

  &__logos {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 40px;

    &__playkids {
      height: 48px;
    }

    &__offer {
      height: 50px;
      margin-left: 30px;
    }
  }

  &__text {
    h2 {
      color: nth($color-custom, 1);
      font: {
        weight: 900;
        size: 2.3rem;
      }
      line-height: 120%;

      span {
        color: nth($color-custom, 2);
      }
    }

    h5 {
      color: nth($color-custom, 1);
      font: {
        weight: 900;
        size: 1.2rem;
      }
    }

    p {
      margin: 1.5em 0;
      line-height: 150%;
    }

    ul {
      li {
        margin: 0.5em 0;

        &::before {
          content: '✔';
          margin-right: 5px;
          color: nth($color-custom, 1);
        }
      }
    }
  }

  &__cta {
    $color: nth($color-custom, 1);

    display: inline-block;
    padding: 15px 60px;
    margin-top: 10px;
    border-radius: 1.5em;
    background: $color;
    color: #fff;
    font: {
      weight: 900;
      size: 1.1rem;
    }
    text-transform: uppercase;

    &:hover {
      background: lighten($color, 5%);
    }
  }

  // Responsiveness
  @include media(map-get($breakpoint, 'medium')) {
    background: none;

    &__container {
      min-height: auto;
      padding: 280px 30px 63px 30px;
      background: {
        image: var(--cover-small);
        position: 50% 0;
        size: 300px auto;
      }
    }

    &__logos {
      justify-content: center;
      margin-bottom: 30px;

      &__playkids {
        height: 48px;
      }

      &__offer {
        height: 40px;
        margin-left: 20px;
      }
    }

    &__text {
      h2 {
        font-size: 2rem;
        line-height: 110%;
        text-align: center;

      }

      h5 {
        font-size: 1.1rem;
      }

      p {
        font-size: 0.95rem;
        line-height: 130%;
      }

      ul {
        li {
          margin: 1em 0;
        }
      }
    }

    &__cta {
      display: block;
      margin-top: 10px;
      border-radius: 1.5em;
      font-size: 1rem;
      text-align: center;
    }
  }
}
</style>
